export const generateUniqueColor = (index: number): string => {
    // Use the golden angle to distribute hues evenly
    const hue = (index * 137.508) % 360

    // Introduce variability in saturation and lightness
    const saturation = 50 + (index % 30) // Saturation ranges from 50% to 80%
    const lightness = 40 + (index % 20) // Lightness ranges from 40% to 60%

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`
}
